<template>
  <div>
    <van-search v-model="keyword" placeholder="搜索" @search="onSearch" @clear="onCancel" shape="round" />
    <!-- <div class="search">
      <van-dropdown-menu active-color="#3974c4">
        <van-dropdown-item v-model="accountId" :options="accountList" @change="selectAccount" />
      </van-dropdown-menu>
    </div> -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="listLoad">
      <van-cell v-for="item in list" :key="item.qwId">
        <div class="list-item">
          <img :src="item.avatar">
          <div class="content">
            <p>{{item.clientName}}</p>
          </div>
          <div class="btn">
            <van-button type="info" @click.native="matching(item.id)">匹配</van-button>
          </div>

        </div>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
export default {
  name: 'selectcustomer',
  data () {
    return {
      keyword: '',
      page: 0,
      pageCount: 10,
      accountId: 0,
      loading: false,
      finished: false,
      accountList: [],
      list: []
    }
  },
  watch: {

  },
  created () {
    // this.getAccount()
    //this.initData()
    console.log(this.$store.state.auth.corpId)
  },
  methods: {
    onSearch () {
      this.page = 1
      this.list = []
      this.loading = false
      this.finished = false,
        this.initData()
    },
    onCancel () {
      this.page = 1
      this.list = []
      this.loading = false
      this.finished = false,
        this.initData()
    },
    onConfirm () {
      this.$refs.item.toggle();
    },
    selectAccount () {
      this.page = 1
      this.list = []
      this.loading = false
      this.finished = false,
        this.initData()
    },
    // 获取全部在线的托管的企业微信
    getAccount () {
      this.$http.get(`/scrm/v1/wxcp-chat-tool/o/findOnlineAccountListBySelf`, {
        params: {
          corpId: this.$store.state.auth.corpId
        },
      }).then((response) => {
        let { code, msg, data } = response
        if (code === 1) {
          this.accountList = data.map(item => {
            return {
              text: item.qwName,
              value: item.id
            }
          })
          this.accountId = this.accountList[0].value
          this.initData(false)
        } else {
          this.$toast(msg)
        }
      })
    },
    // 获取托管微信下所有好友
    initData () {
      this.$http.post(`/scrm/v1/wxcp-chat-tool/o/findQwClientListByPage?corpId=${this.$store.state.auth.corpId}`, {
        accountId: this.$store.state.auth.qwAccountId,
        page: this.page,
        pageCount: this.pageCount,
        keyword: this.keyword,
      }).then((response) => {
        this.loading = false
        let { data, code, msg, total } = response
        if (code === 1) {
          if (data === null) {
            data = {}
            data.records = []
          }

          if (data.records.length !== 0) {
            this.list.push(...data.records)
          } else {
            this.finished = true;
          }
        } else {
          this.$toast(`${msg}`)
        }
        if (this.list.length >= total) {
          this.finished = true;
        }
      })
    },
    listLoad () {
      this.page++
      this.initData()

    },
    //匹配客户
    matching (qwClientId) {
      console.log(this.$store.state.auth.externalUserId)
      this.$http.post(`/scrm/v1/wxcp-chat-tool/o/bindQwClient?corpId=${this.$store.state.auth.corpId}`, {
        corpId: this.$store.state.auth.corpId,
        qwClientId: qwClientId,
        externalUserId: this.$store.state.auth.externalUserId,
      }).then((response) => {
        if (response.code == 1) {
          this.$router.push({
            path: '/samrtSendOrder',
            query: {

            }
          })
        } else {
          this.$toast(msg)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.search {
  width: 100%;
  padding: 0 10px 0 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /deep/ .van-dropdown-menu {
    width: 100%;
  }
  /deep/ .van-dropdown-menu__bar {
    // width: 80px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
    font-size: 15px;
  }
  /deep/.van-search {
    width: 70%;
  }
}
.search-group {
  /deep/ .van-dropdown-menu__bar {
    width: 200px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
    font-size: 15px;
  }
  /deep/ .van-dropdown-menu__title::after {
    // right: -0.10667rem;
    margin-top: -0.16rem;
    border: 0.11rem solid;
    border-color: transparent transparent #3974c4 #3974c4;
  }
}
.list-item {
  display: flex;
  align-items: center;
  img {
    height: 40px;
    border-radius: 50%;
  }
  .content {
    margin: 0px 20px;
    flex: 1;
    p {
      font-size: 16px;
    }
  }
  .btn {
    .van-button {
      height: 32px;
      border-radius: 6px;
    }
  }
}
</style>
